// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible';
import BaiduMap from 'vue-baidu-map'
import moment from 'moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)
import FastClick from 'fastclick' //移除移动端点击延迟
FastClick.attach(document.body);

Vue.prototype.moment = moment;//赋值使用
Vue.use(BaiduMap, {
  ak: '9iV5tbz0CAGDOKg5qlbuNd7AEweMP5LQ'
})
// 修复点击300ms延迟
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body)
  }, false)
}
FastClick.prototype.focus = function (targetElement) {
  targetElement.focus();
  10
};

Vue.use(Vant);
Vue.config.productionTip = false

import utils from './api/utils'
import {AxiosPost} from "./api/axios";

router.beforeEach((to, from, next) => {
  if (to.name == 'shareCoupon' && utils.getIsWxClient()) {
    const code = utils.getUrlParam('code');//获取url 上面的code
    // 还未完成微信授权
    if (!code) {
      //假如没code
      //请求微信服务器获取code
      let data = {
        url: window.location.href,                //类型：String  必有字段  备注：当前页面URL+ window.location.href
        scope: "snsapi_base",                //类型：String  必有字段  备注：snsapi_base==>静默授权；snsapi_userinfo==>网页授权
        state: "123",                //类型：String  必有字段  备注：重定向后会带上state参数，开发者可以填写a-zA-Z0-9的参数值，最多128字节
        wechatType: "group",                //类型：String  必有字段  备注：show--车展 ｜ group--团购
      }
      AxiosPost('member/login/oauth2', data).then(res => {
        // console.log(res);
        if (res.code == 200) {
          console.log(res.data.url);
          window.location.href = res.data.url
        } else {

        }

      })
    } else {
      let data = {
        session_id: '',
        code: code,               //类型：String  必有字段  备注：微信CODE
        wechatType: "group"                //类型：String  必有字段  备注：show--车展 ｜ group--团购
      }
      AxiosPost('/member/login/wechat', data).then(res => {
        console.log(res);
        if (res.code == 200) {
          utils.setLocalStorage('ztAPP.SHARE', res.data);
        }
      })
      next()
    }
  } else {
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js